import Vue from 'vue'
import ElementUI from 'element-ui'; //引入element组件库
import 'element-ui/lib/theme-chalk/index.css'; //引入element样式文件
import './assets/css/flex.css';
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/font/iconfont.css'
import TD from "./utils/thinkingdata" 
import axios from 'axios' 

Vue.config.productionTip = false
Vue.use(ElementUI); //使用element --------------------------------- 
Vue.prototype.$td = TD.TD;
// 设置自定义事件  
Vue.prototype.$http = axios; 
//axios拦截器，发送请求之前操作
const on = Vue.prototype.$on
if (process.env.NODE_ENV === 'production') {
  if (window) {
    // 过滤掉生成环境的所有log
    window.console.log = function () {};
  }
}
store.state.keysEnd = "(N9th2pD8jA)"; 

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
